import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import React from 'react';
import { ImageWithCaptionStyles as S } from './ImageWithCaption.styles';
const ImageWithCaption = (props) => {
    const args = getImageArgs(props.size ?? 'default');
    const sizes = getImageSizes(props.size ?? 'default');
    const srcs = getSrcs(props.image, args[0], args[1], 5);
    return (React.createElement(S.Container, { id: props.anchorId, "data-size": props.size ?? 'default' },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaHolder, null,
                React.createElement(S.Image, { alt: props.image?.altText ?? '', loading: "lazy", role: props.image?.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes })),
            props.captionContent && (React.createElement(S.ImageCaption, null,
                props.captionLabel && React.createElement("strong", null, props.captionLabel),
                props.captionContent)))));
    function getImageArgs(size) {
        switch (size) {
            case 'medium':
                return [960, 513];
            case 'small':
                return [707, 421];
            default:
                return [1347, 513];
        }
    }
    function getImageSizes(size) {
        switch (size) {
            case 'medium':
                return `${until(Device.MobileLarge)} 100vw, ${until(Device.Tablet)} 83vw, ${until(Device.TabletLarge)} 66vw, ${until(Device.DesktopLarge)} 50vw, 666px`;
            case 'small':
                return `${until(Device.MobileLarge)} 83vw, ${until(Device.Tablet)} 66vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopLarge)} 33vw, 434px`;
            default:
                return `${until(Device.Tablet)} 100vw, ${until(Device.TabletLarge)} 83vw, ${until(Device.DesktopLarge)} 66vw, 898px`;
        }
    }
};
export default ImageWithCaption;
